import {
  FC, useEffect, useState, useMemo,
} from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Content, Layout, Sider } from 'shared/ui/Layout';
import { AppHeader } from 'widgets/AppHeader';
import { useAppDispatch, useAppSelector } from 'app/providers/Store';
import { Menu, MenuProps } from 'antd';
import {
  TeamOutlined,
  SettingOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  FolderOpenOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { FloatingFeedbackButton } from 'shared/ui/FloatingFeedbackButton';
import { userSelectors } from 'entities/user';
import styles from './AppLayout.module.scss';

type MenuItem = Required<MenuProps>['items'][number];

const locationMenuMap: Record<string, string> = {
  '/orders': 'orders',
  '/engines': 'engines',
  '/feedback': 'feedback',
  '/users': 'users',
  '/formalized-zip': 'formalized-zip',
  '/unformalized-zip': 'unformalized-zip',
};

export const AppLayout:FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const hasAdminRole = useAppSelector(userSelectors.hasAdminRole);

  const allMenuItems = useMemo<MenuItem[]>(() => [
    {
      key: 'engines', label: 'Машины', icon: <SettingOutlined />, onClick: () => navigate('/engines'),
    },
    {
      key: 'orders', label: 'Заявки', icon: <ShoppingCartOutlined />, onClick: () => navigate('/orders'),
    },
    {
      key: 'feedback', label: 'Отзывы', icon: <MessageOutlined />, onClick: () => navigate('/feedback'),
    },
    {
      key: 'users', label: 'Пользователи', icon: <TeamOutlined />, onClick: () => navigate('/users'),
    },
    {
      key: 'formalized-zip', label: 'Формализованные ЗИП', icon: <FileTextOutlined />, onClick: () => navigate('/formalized-zip'),
    },
    {
      key: 'unformalized-zip', label: 'Список ЗИПа', icon: <FolderOpenOutlined />, onClick: () => navigate('/unformalized-zip'),
    },
  ], [navigate]);

  const items = useMemo(() => {
    if (hasAdminRole) {
      return allMenuItems;
    }
    return allMenuItems.filter((item) => ['engines', 'orders', 'unformalized-zip'].includes(item.key as string));
  }, [hasAdminRole, allMenuItems]);

  useEffect(() => {
  }, [dispatch]);

  return (
    <Layout>
      <AppHeader />
      <FloatingFeedbackButton />
      <Layout>
        <Sider theme="dark" collapsible collapsed={collapsed} collapsedWidth={50} width={250} onCollapse={(value) => setCollapsed(value)}>
          <div className="demo-logo-vertical" />
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" items={items} selectedKeys={[locationMenuMap[location.pathname]]} />
        </Sider>
        <Layout>
          <Content className={styles.pageContainer}>
            <Layout className={styles.outletLayout}>
              <div className={styles.pageContent}>
                <Outlet />
              </div>
            </Layout>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};
